/**
 * @author Blueprint Frontend Team
 */
import "../scss/index.scss";
import { applyForm } from './modules';
import { header } from './layouts';
import { slider, tabs, accordion, lightbox, inputs, handWoven } from './components';

import { loadPage } from './utils';

(function () {
  loadPage.init();
  applyForm.init();

  // Layouts
  header.init();


  // Partials Modules
  slider.init();
  tabs.init();
  accordion.init();
  lightbox.init();
  inputs.init();
  handWoven.init();


  // Page Modules
}());
